var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1794",
    "data-name": "Group 1794",
    transform: "translate(-48 -201.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 201.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1737",
    "data-name": "Group 1737",
    transform: "translate(50 203.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M7.7,0H1.457A1.459,1.459,0,0,0,0,1.457V5.205A1.459,1.459,0,0,0,1.457,6.663H7.7A1.459,1.459,0,0,0,9.161,5.205V1.457A1.459,1.459,0,0,0,7.7,0Zm0,0",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M7.7,213.332H1.457A1.459,1.459,0,0,0,0,214.79v8.745a1.459,1.459,0,0,0,1.457,1.457H7.7a1.459,1.459,0,0,0,1.458-1.457V214.79A1.459,1.459,0,0,0,7.7,213.332Zm0,0",
    transform: "translate(0 -204.992)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M285.036,341.332H278.79a1.459,1.459,0,0,0-1.458,1.458v3.748a1.459,1.459,0,0,0,1.458,1.457h6.246a1.459,1.459,0,0,0,1.457-1.457V342.79A1.459,1.459,0,0,0,285.036,341.332Zm0,0",
    transform: "translate(-266.493 -327.995)",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M285.036,0H278.79a1.459,1.459,0,0,0-1.458,1.457V10.2a1.459,1.459,0,0,0,1.458,1.458h6.246a1.459,1.459,0,0,0,1.457-1.458V1.457A1.459,1.459,0,0,0,285.036,0Zm0,0",
    transform: "translate(-266.493)",
    fill: "#15345a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFillIcon);
export default __webpack_public_path__ + "static/media/dashboardFillIcon.7cfa688a3a8083e36eadca4894c4470d.svg";
export { ForwardRef as ReactComponent };